export default __webpack_public_path__ + "static/media/mytutku1.58cf2473.jpg";